import ScrollToTop from "./ScrollToTop";

export {installBodyClass, onScrollTopChange, offScrollTopChange} from "./browser";
export default ScrollToTop;
